import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="select"
export default class extends Controller {
  connect() {
    const isMultiple = this.element.multiple
    new TomSelect(this.element, {
      create: false,
      allowEmptyOption: !isMultiple,
      placeholder: this.element.dataset.placeholder || "Bitte auswählen …",
      plugins: isMultiple ? ['remove_button'] : []
    })
  }
}
